import React, { useRef } from 'react';
var VeltAutocompleteChipTooltipDescription = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-autocomplete-chip-tooltip-description", { ref: ref }, children));
};
export default VeltAutocompleteChipTooltipDescription;
